// extracted by mini-css-extract-plugin
export default {"reviewCard":"OrderReview_reviewCard__YN366","rating":"OrderReview_rating__OLb2Z","orderRating":"OrderReview_orderRating__YaZOr"};